import React from "react";
import { useTranslation } from "react-i18next";

import useFacilityReviews from "./hooks/useFacilityReviews";
import { ReviewData } from "../../../models/ReviewData";
import ReviewItem from "../ReviewItem";

import "./styles.scss";

interface IRecentReviewsSectionProps {
  locationId: string;
}

export const RecentReviewsSection: React.FunctionComponent<
  IRecentReviewsSectionProps
> = ({ locationId }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.recentReviews.${key}`);

  const { data: recentReviews = [], isLoading: loading } = useFacilityReviews({
    locationId,
    sort: "review_date",
    order: "desc",
    limit: 3,
    offset: 0,
  });

  if (loading) {
    return (
      <div className="white-border-panel">
        <div className="section-header">
          <h3 className="section-title">{t("title")}</h3>
        </div>
        <div className="loading-container">
          <div className="loading-text">{t("loading")}</div>
        </div>
      </div>
    );
  }

  if (recentReviews.length === 0) {
    return (
      <div className="white-border-panel recent-reviews-section padding32 ">
        <div className="section-header">
          <h3 className="section-title">{t("title")}</h3>
        </div>
        <div className="reviews-container">
          <div>{t("noReviews")}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="white-border-panel recent-reviews-section padding32 ">
      <div className="section-header">
        <h3 className="section-title">{t("title")}</h3>
      </div>

      <div className="reviews-container">
        {recentReviews.map((review: ReviewData) => (
          <ReviewItem key={review.review_id} review={review} />
        ))}
      </div>
      {recentReviews.length > 0 && (
        <div className="view-more-container">
          <button className="btn btn-blue">{t("viewMore")}</button>
        </div>
      )}
    </div>
  );
};

export default RecentReviewsSection;
